module.exports = __webpack_public_path__ + "static/media/Паспорт ШУНО АХП.8145fa53.pdf";